/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { PostSmsVerifyConfirmMutationRequest, PostSmsVerifyConfirmMutationResponse, PostSmsVerifyConfirm400, PostSmsVerifyConfirm429, PostSmsVerifyConfirm500, PostSmsVerifyConfirm502 } from "../models/PostSmsVerifyConfirm";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postSmsVerifyConfirmMutationKey = () => [{ url: '/api/v1/sms/verify/confirm' }] as const

export type PostSmsVerifyConfirmMutationKey = ReturnType<typeof postSmsVerifyConfirmMutationKey>

/**
 * @description Confirms the code the user entered. On a match, records phone-keyed SMS consent — a lead later created with that number inherits it. Public/anonymous; rate-limited.
 * @summary Confirm SMS opt-in verification code
 * {@link /api/v1/sms/verify/confirm}
 */
export async function postSmsVerifyConfirm({ data }: { data: PostSmsVerifyConfirmMutationRequest }, config: Partial<RequestConfig<PostSmsVerifyConfirmMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostSmsVerifyConfirmMutationResponse, ResponseErrorConfig<PostSmsVerifyConfirm400 | PostSmsVerifyConfirm429 | PostSmsVerifyConfirm500 | PostSmsVerifyConfirm502>, PostSmsVerifyConfirmMutationRequest>({ method : "POST", url : `/api/v1/sms/verify/confirm`, data : requestData, ... requestConfig })
  return res
}

export function postSmsVerifyConfirmMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostSmsVerifyConfirmMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postSmsVerifyConfirmMutationKey()
        return mutationOptions<ResponseConfig<PostSmsVerifyConfirmMutationResponse>, ResponseErrorConfig<PostSmsVerifyConfirm400 | PostSmsVerifyConfirm429 | PostSmsVerifyConfirm500 | PostSmsVerifyConfirm502>, {data: PostSmsVerifyConfirmMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postSmsVerifyConfirm({ data }, config)
          },
        })

}

/**
 * @description Confirms the code the user entered. On a match, records phone-keyed SMS consent — a lead later created with that number inherits it. Public/anonymous; rate-limited.
 * @summary Confirm SMS opt-in verification code
 * {@link /api/v1/sms/verify/confirm}
 */
export function usePostSmsVerifyConfirm<TContext>(options: 
{
  mutation?: UseMutationOptions<ResponseConfig<PostSmsVerifyConfirmMutationResponse>, ResponseErrorConfig<PostSmsVerifyConfirm400 | PostSmsVerifyConfirm429 | PostSmsVerifyConfirm500 | PostSmsVerifyConfirm502>, {data: PostSmsVerifyConfirmMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostSmsVerifyConfirmMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postSmsVerifyConfirmMutationKey()

          const baseOptions = postSmsVerifyConfirmMutationOptions(config) as UseMutationOptions<ResponseConfig<PostSmsVerifyConfirmMutationResponse>, ResponseErrorConfig<PostSmsVerifyConfirm400 | PostSmsVerifyConfirm429 | PostSmsVerifyConfirm500 | PostSmsVerifyConfirm502>, {data: PostSmsVerifyConfirmMutationRequest}, TContext>
          

          return useMutation<ResponseConfig<PostSmsVerifyConfirmMutationResponse>, ResponseErrorConfig<PostSmsVerifyConfirm400 | PostSmsVerifyConfirm429 | PostSmsVerifyConfirm500 | PostSmsVerifyConfirm502>, {data: PostSmsVerifyConfirmMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ResponseConfig<PostSmsVerifyConfirmMutationResponse>, ResponseErrorConfig<PostSmsVerifyConfirm400 | PostSmsVerifyConfirm429 | PostSmsVerifyConfirm500 | PostSmsVerifyConfirm502>, {data: PostSmsVerifyConfirmMutationRequest}, TContext>
      
}